import React from "react";

/* NOTE: This hook should only be used internally */
// Add the ability to hide the nav with a GET param
// - Team Nucleus renders the Fabric web app in a mobile webview and provides their own native nav
// - We set the value in a state variable so the url param doesn't need to persist,
//   and apps are free to do whatever craziness to the url they want (smh)
export const useNav = (): boolean => {
  const searchParams = new URLSearchParams(window.location.search);
  const [hideNav] = React.useState(searchParams.get("nav") === "false");
  return !hideNav;
};
